import * as React from "react";
import { observable, action } from "mobx";
import { observer } from "mobx-react";

import * as CustomLists from "../../models/customLists";
import CategoryMenuStore from "../../stores/CategoryMenuStore";
import { FolderBrowserFetchList } from "./FolderBrowserFetchList";
import { strings } from "../../core/localizedStrings";
import Breadcrumbs from "../Breadcrumbs";
import { Fonts } from "../../core/utils/Fonts";

import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FolderIcon from "@material-ui/icons/CreateNewFolder";
import { Colors } from "core/utils/Colors";

var Row = require("react-flexbox-grid").Row;

export interface FolderBrowserProps extends React.Props<any> {
    titleMessage: string;
    onFolderSelected: (folder: CustomLists.Folder) => void;
    store: CategoryMenuStore;
}

@observer
export class FolderBrowser extends React.Component<FolderBrowserProps> {
    @observable
    private newFolderName: string;

    public render() {
        return this.renderListView();
    }

    @action
    private onTextChanged = (event: any) => {
        this.newFolderName = event.currentTarget.value;
    };

    @action
    private onAddFolderClicked = () => {
        if (this.newFolderName !== undefined && this.newFolderName.length > 0) {
            this.props.store.addFolderForFolderBrowser(this.newFolderName);
            this.newFolderName = "";
        }
    };

    private onKeyDown = (event: any) => {
        if (event.keyCode === 13) {
            this.onAddFolderClicked();
        }
    };

    private onOkClicked = () => {
        this.props.onFolderSelected(this.props.store.folderBrowserCategoryMenuFolder.currentFolder);
    };

    private renderListView() {
        return (
            <div style={{ margin: 20 }}>
                <Typography variant="h6">{this.props.titleMessage}</Typography>
                <div style={{ paddingTop: 15, fontFamily: Fonts.BalsamiqSans }}>
                    <Breadcrumbs
                        store={this.props.store}
                        fontSize={30}
                        fontColor={Colors.facebookBlue}
                        isFolderBrowser={true}
                    />
                </div>
                <Typography style={{ paddingTop: 25 }} variant="subtitle1">
                    Add or select a subfolder:
                </Typography>
                <Row middle="xs">
                    <TextField
                        style={{ marginLeft: 7, marginRight: 10 }}
                        label="Add New Folder"
                        value={this.newFolderName}
                        onChange={this.onTextChanged}
                        onKeyDown={this.onKeyDown}
                    />
                    <Button onClick={this.onAddFolderClicked}>
                        <FolderIcon />
                        {strings.add}
                    </Button>
                </Row>
                <div style={{ paddingTop: 10, minHeight: 250, maxHeight: 350, overflowY: "auto" }}>
                    <FolderBrowserFetchList store={this.props.store} />
                </div>

                <div style={{ textAlign: "right" }}>
                    <Button variant="contained" onClick={this.onOkClicked}>
                        {strings.ok}
                    </Button>
                </div>
            </div>
        );
    }
}
